import React from 'react';
import { Table, TableProps, UsePaginationState } from '@odin-labs/components';

/** Keep the current page through refreshes, moving back only if it disappears. */
export function AccessGroupsTable<Row extends Record<string, unknown>>({
  data,
  ...props
}: TableProps<Row>): React.ReactElement {
  return (
    <Table
      {...props}
      data={data}
      stateReducer={(
        state: UsePaginationState<Row>,
        action: { type: string },
        previous: UsePaginationState<Row>,
      ) =>
        action.type === 'resetPage'
          ? {
              ...state,
              pageIndex: Math.min(
                previous.pageIndex,
                Math.max(0, Math.ceil(data.length / state.pageSize) - 1),
              ),
            }
          : state
      }
    />
  );
}
